import { ClipperProps } from '@components/Clipper';
import { PaywallProps } from '@components/Paywall';
import { MidArticleEventProps } from '@components/pages/Article/MidArticle/Event/interfaces';
import { Env } from '@contexts/AppContext';
import { Article, MostPopularArticle } from '@interfaces/homepage';
import { User } from '@utils/backend-api/currentUser';

export enum ArticleTheme {
  Feature = 'feature',
  Graphic = 'graphic',
  Standard = 'standard',
  Weekend = 'weekend',
}

// TODO: Remove after experiment
// {@link https://app.asana.com/0/1201413338509198/1208029113890850/f}
export enum PaywallVariant {
  FullBleed = 'full_bleed',
  Standard = 'standard',
  TwoOption = 'two_option',
}

export enum MidArticleUnitTypes {
  DeepResearch = 'deep_research',
  Event = 'event',
  Recirc = 'recirc',
}

export interface SuggestedAiPrompt {
  category: string;
  icon: string;
  prompt: string;
}

export interface ArticleProps extends ThemeViewsProps {
  hideAwarenessBar: boolean;
  isGdprRequired: boolean;
  isWebview: boolean;
  newsletterId?: number | string;
  offerCode?: string;
  paywallProps?: PaywallProps;
  theme: ArticleTheme;
  unlockedVia: string;
  shareGuid: string;
}

export interface ThemeViewsProps {
  article: Article;
  canShareArticle: boolean;
  canViewFullArticle: boolean;
  canViewComments: boolean;
  clipperProps: ClipperProps;
  env: Env;
  initialCurrentUser?: User;
  isSEOBotAndArticleIsNotFree: boolean;
  midArticleUnitType?: MidArticleUnitTypes;
  mostPopularArticles: MostPopularArticle[];
  newsletterId?: string | number;
  relatedArticles: Article[];
  relatedEvent?: MidArticleEventProps;
  suggestedAiPrompts?: SuggestedAiPrompt[];
}
